import { render, staticRenderFns } from "./partnerOrderItemsTable.vue?vue&type=template&id=0fd2bccf&"
import script from "./partnerOrderItemsTable.vue?vue&type=script&lang=ts&"
export * from "./partnerOrderItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports